'use strict';

// eslint-disable-next-line strict
var Swiper = require('swiper/bundle'); // .default;// .esm.browser.bundle
var isMobile = $(window).width() < 768;
var isMobileTablet = $(window).width() < 1200;
var base = require('./base');
// var toastr = require('toastr');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements:
			updateAddToCartEnableDisableOtherElements,
    },

    // availability: base.availability,

    // addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer
                .find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer
                    .find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer
                    .find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer
                    .find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer
                    .find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on(
            'product:beforeAddToCart product:beforeAttributeSelect',
            function () {
                $.spinner().start();
            }
        );
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data(
                    'pid',
                    response.data.product.id
                );
            }
            // eslint-disable-next-line no-undef
            if (typeof _ltk != 'undefined') {
                // eslint-disable-next-line no-undef
                _ltk.Activity.AddProductBrowse(response.data.product.id);
            }
        });
    },

    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                !response.product.readyToOrder || !response.product.available
            );

            // logic to update the UI with OOS message
            if ($('button.add-to-cart').length > 0) {
                // pdp page
                if (!response.product.readyToOrder || !response.product.available) {
                    // reset the layout to have quantity selector and remove the oos msg
                    $('.js-oos-msg-container', response.$productContainer)
                        .removeClass('d-none')
                        .find('.js-oos-msg')
                        .text('Product Currently Out of Stock');
                    $(
                        '.js-pdp-qty-select-container',
                        response.$productContainer
                    ).addClass('d-none');
                } else {
                    // reset the layout to have quantity selector and remove the oos msg
                    $('.js-oos-msg-container', response.$productContainer).addClass(
                        'd-none'
                    );
                    $(
                        '.js-pdp-qty-select-container',
                        response.$productContainer
                    ).removeClass('d-none');
                }
            }

            var enable = $('.product-availability')
                .toArray()
                .every(function (item) {
                    return $(item).data('available') && $(item).data('ready-to-order');
                });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },

    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty()
                .html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(
                        allReady ? response.message : response.resources.info_selectforstock
                    );
            }
        });
    },

    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this)
                .closest('.size-chart')
                .find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    },
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },

    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    initIncludedInSlider: function () {
        var $sliderDOMElm = $('.js-included-product-slider .swiper');
        if ($sliderDOMElm.length > 0) {
            var swiperInitialState = {
                slidesPerView: 3,
                spaceBetween: 16,
                pagination: {
                    el: '.js-included-product-slider .swiper-pagination',
                    type: isMobile ? 'bullets' : 'fraction',
                },
                navigation: {
                    nextEl: '.js-included-product-slider .swiper-button-next',
                    prevEl: '.js-included-product-slider .swiper-button-prev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                },
            };

            new Swiper.default(
                '.js-included-product-slider .swiper',
                swiperInitialState
			); // eslint-disable-line
        }
    },

    initSetProductSlider: function () {
        var $sliderDOMElm = $('.js-set-items-slider .swiper');
        if ($sliderDOMElm.length > 0) {
            var swiperInitialState = {
                slidesPerView: 'auto',
                spaceBetween: 20,
                threshold: 5,
                navigation: {
                    nextEl: '.js-set-items-slider .swiper-button-next',
                    prevEl: '.js-set-items-slider .swiper-button-prev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                        spaceBetween: 32,
                    },
                },
            };

			new Swiper.default('.js-set-items-slider .swiper', swiperInitialState); // eslint-disable-line
        }
    },

    pdpMainImageSlider: function () {
        var $sliderDOMElm = $('.js-primary-image-slider .swiper');
        if ($sliderDOMElm.length > 0) {
            var swiperInitialState = {};
            if (isMobileTablet) {
                swiperInitialState = {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    pagination: {
                        el: '.js-primary-image-slider .swiper-pagination',
                        type: isMobileTablet ? 'bullets' : 'fraction',
                    },
                    navigation: {
                        nextEl: '.js-primary-image-slider .swiper-button-next',
                        prevEl: '.js-primary-image-slider .swiper-button-prev',
                    },
                    grabCursor: true,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    spaceBetween: 10,
                    initialSlide: 0,
                    on: {
                        click(event) {
                            var slideClicked = event.clickedSlide;
                            if (slideClicked) {
                                var $imageElement = $(slideClicked).find('img');
                                if ($imageElement.hasClass('video')) {
                                    // trigger youtube popup launch events
                                    var videoID = $imageElement.data('video-id');
                                    var params = $imageElement.data('video-params');
                                    $('body').trigger('triggerVideoModalPdp', {
                                        videoId: videoID,
                                        params: params,
                                    });
                                }
                            }
                        },
                    },
                };
            } else {
                swiperInitialState = {
                    direction: 'vertical',
                    slidesPerView: 6,
                    pagination: {
                        el: '.js-primary-image-slider .swiper-pagination',
                        type: isMobile ? 'bullets' : 'fraction',
                    },
                    navigation: {
                        nextEl: '.js-primary-image-slider .swiper-button-next',
                        prevEl: '.js-primary-image-slider .swiper-button-prev',
                    },
                    grabCursor: true,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    spaceBetween: 10,
                    initialSlide: 0,
                    on: {
                        click(event) {
                            var slideClicked = event.clickedSlide;
                            if (slideClicked) {
                                var $imageElement = $(slideClicked).find('img');
                                $(slideClicked)
                                    .addClass('active')
                                    .siblings()
                                    .removeClass('active');
                                if ($imageElement.hasClass('video')) {
                                    // trigger youtube popup launch events
                                    var videoID = $imageElement.data('video-id');
                                    var params = $imageElement.data('video-params');
                                    $('body').trigger('triggerVideoModalPdp', {
                                        videoId: videoID,
                                        params: params,
                                    });
                                } else {
                                    var imageSrc = $imageElement.attr('src');
                                    if (imageSrc) {
                                        $('.primary-images img').attr('src', imageSrc);
                                    }
                                }
                            }
                        },
                    },
                };
            }

            new Swiper.default(
                '.js-primary-image-slider .swiper',
                swiperInitialState
			); // eslint-disable-line
        }
    },

    handleGiftMessageLength: base.handleGiftMessageLength,

    updateGiftCertificateDeliveryDate: function () {
        if (document.getElementById('giftcert_purchase_deliveryDate')) {
            document.getElementById('giftcert_purchase_deliveryDate').valueAsDate =
				new Date();
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; // January is 0!
            var yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }
            today = yyyy + '-' + mm + '-' + dd;
            document
                .getElementById('giftcert_purchase_deliveryDate')
                .setAttribute('min', today);
        }
    },

    showMoreKit: function () {
        $(document).on('click', '.js-show-more-kit-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $kitItems = $this.parent().find('.js-show-more-kit');

            if ($kitItems.hasClass('show')) {
                $kitItems.removeClass('show');
                $this.text('See more');
            } else {
                $kitItems.addClass('show');
                $this.text('See less');
            }
        });
    },

    showMorSteps: function () {
        $(document).on('click', '.js-show-more-steps-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $kitItems = $('.js-steps-init');

            if ($kitItems.find('.hide').length > 0) {
                $kitItems.find('.hide').removeClass('hide');
                $this.text('See less');
            } else {
                module.exports.projectsSteps();
                $this.text('See more');
            }
        });
    },

    showMorSpecifications: function () {
        $(document).on('click', '.js-show-specifications-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $kitItems = $('.js-steps-init');

            if ($kitItems.find('.hide').length > 0) {
                $kitItems.find('.hide').removeClass('hide');
                $this.text('See less');
            } else {
                module.exports.projectsSpecifications();
                $this.text('See more');
            }
        });
    },

    handleViewInstruction: function () {
        $('body').on('click', '.js-view-instruction', function () {
            if ($('.set-instrcution').length) {
                $('html, body').animate(
                    {
                        scrollTop: $('.set-instrcution').offset().top - 150,
                    },
                    500
                );
            }
        });
    },

    projectsSteps: function () {
        $('.steps-content').each(function () {
            // Check if the current .steps-content contains any child with class .bb-steps
            var bbStepsChildren = $(this).find('.bb-steps');
            if (bbStepsChildren.length > 0) {
                bbStepsChildren.removeClass('highlight').first().addClass('highlight');
                // Get all immediate children of the current .steps-content
                var children = $(this).children();
                $(this).addClass('js-steps-init');

                // If there are more than 2 children, add the highlight class to the remaining ones
                if (children.length > 2) {
                    // Add the highlight class to the children after the second one
                    children.slice(2).addClass('hide');
                }
            }
        });
    },

    projectsSpecifications: function () {
        $('.bb-specifications').each(function () {
            // Check if the current .steps-content contains any child with class .bb-steps
            var bbStepsChildren = $(this).find('li');
            if (bbStepsChildren.length > 0) {
                // Get all immediate children of the current .steps-content
                var children = $(this).children();
                $(this).addClass('js-steps-init');

                // If there are more than 2 children, add the highlight class to the remaining ones
                if (children.length > 2) {
                    // Add the highlight class to the children after the second one
                    children.slice(5).addClass('hide');
                }
            }
        });
    },

    highlightSteps: function () {
        $(document).on('click', '.bb-steps', function (e) {
            e.preventDefault();
            var $this = $(this);
            $this.addClass('highlight').siblings().removeClass('highlight');
        });
    },

    whatYouNeedSlider: function () {
        var $sliderDOMElm = $('.js-what-you-need .swiper');
        if ($sliderDOMElm.length > 0) {
            var swiperInitialState = {
                slidesPerView: 'auto',
                spaceBetween: 20,
                threshold: 5,
                navigation: {
                    nextEl: '.js-what-you-need .swiper-button-next',
                    prevEl: '.js-what-you-need .swiper-button-prev',
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 6,
                        spaceBetween: 32,
                    },
                },
            };

			new Swiper.default('.js-what-you-need .swiper', swiperInitialState); // eslint-disable-line
        }
    },

    whatYouNeedSliderAjax: function () {
        window.addEventListener('pdpReady', function () {
            var $sliderDOMElm = $('.js-what-you-need .swiper');
            if ($sliderDOMElm.length > 0) {
                var swiperInitialState = {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    threshold: 5,
                    navigation: {
                        nextEl: '.js-what-you-need .swiper-button-next',
                        prevEl: '.js-what-you-need .swiper-button-prev',
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 32,
                        },
                    },
                };

				new Swiper.default('.js-what-you-need .swiper', swiperInitialState); // eslint-disable-line
            }
        });
    },

    // handleVariantSaleMaxLogic: function () {
    //     // eslint-disable-next-line consistent-return
    //     $('.js-pdp-qty-select-container .js-show-sale-max').on(
    //         'keyup mouseup',
    //         function (e) {
    //             e.stopPropagation();
    //             var currentValue = parseInt($(this).val(), 10);
    //             var maxsale = parseInt($(this).attr('data-max-sale-allowed'), 10);
    //             if (currentValue >= maxsale) {
    //                 $(this).val(maxsale);
    //                 toastr.remove();
    //                 toastr.error('Quantity Limited to ' + maxsale);
    //                 return false;
    //             }
    //             return true;
    //         }
    //     );
    //     return true;
    // },
};
